import React from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';

function UserDetailModal(props) {
  const { open, close, data } = props;

  if (!open) return null;

  return (
    <Dialog open={open} onClose={close} closeOnOverlayClick={true}>
      <div className="modal-detail" style={{ margin: '20px 70px' }}>
        <p className="mc-name">Detalles del estudiante</p>
        <div className="">
          <p className="mc-name">Nombre:</p>
          <p className="mc-text">{data.names}</p>
          <p className="mc-name">Apellidos:</p>
          <p className="mc-text">{data.lastNames}</p>
          <p className="mc-name">Matricula:</p>
          <p className="mc-text">{data.scholarID}</p>
          <p className="mc-name">Correo electrónico:</p>
          <p className="mc-text">{data.email}</p>
          <p className="mc-name">Pregunta de validación:</p>
          <p className="mc-text">{data.currentQuestion}</p>
          <p className="mc-name">Respuesta:</p>
          <p className="mc-text">{data.question}</p>
        </div>
      </div>
    </Dialog>
  );
}

export default UserDetailModal;
